import React from 'react';

import Events from '@/pages/Common/Events';
import ViewEvent from '@/pages/Common/Events/ViewEvent';
import Glossary from '@/pages/Common/Glossary';
import Watch from '@/pages/Common/Glossary/Watch';
import Notifications from '@/pages/Common/Notifications';
import SimulatorsInputs from '@/pages/Common/Property/tabs/SimutalorsInputs';
import DashboardLayout from '@components/templates/layouts/Outlet/DashboardLayout';
import VisitAbsences from '@/pages/Consultant/VisitAbsences';

const Home = React.lazy(() => import('pages/Consultant/Home'));
const DynamicConsultantHome = React.lazy(() => import('pages/Consultant/DynamicHome'));

const Error404 = React.lazy(() => import('pages/Errors/404'));
const Properties = React.lazy(() => import('pages/Common/Properties'));
const Schedule = React.lazy(() => import('@/pages/Common/Schedule'));
const NewProperty = React.lazy(() => import('pages/Common/Properties/NewProperty'));
const Property = React.lazy(() => import('@/pages/Common/Property'));
const ConsultantRoutes = {
    path: '/consultor',
    element: <DashboardLayout />,
    children: [
        // TODO: Verificar se precisa manter essa Home (Agenda, Blog, Eventos)
        // {
        //     path: '/consultor',
        //     element: <Home />
        // },
        // TODO: Anteriormente era /consultor/propriedades
        // Rota dinâmica: currentSegment = 1 -> Properties, currentSegment = 2 -> Home
        {
            path: '/consultor',
            element: <DynamicConsultantHome />
        },

        {
            path: '/consultor/propriedades',
            element: <Properties />
        },

        {
            path: `/consultor/propriedades/:propId/:tab?/:entityId?/:entityAction?`,
            element: <Property />
        },

        {
            path: '/consultor/agenda',
            element: <Schedule />
        },
        {
            path: '/consultor/propriedades/nova-propriedade',
            element: <NewProperty />
        },
        {
            path: `/consultor/propriedades/editar-propriedade/:propId`,
            element: <NewProperty />
        },
        {
            path: '/consultor/'
        },
        {
            path: '/consultor/glossario',
            element: <Glossary />
        },
        {
            path: '/consultor/glossario/assistir/:id',
            element: <Watch />
        },
        {
            path: '/consultor/notificacoes',
            element: <Notifications />
        },
        {
            path: '/consultor/encontros-ao-vivo',
            element: <Events />
        },
        {
            path: '*',
            element: <Error404 />
        },
        {
            path: '/consultor/encontros-ao-vivo/:id',
            element: <ViewEvent />
        },
        {
            path: '/consultor/justificativas',
            element: <VisitAbsences />
        },

        //mobile
        {
            path: `mobile/propriedades/:propId/:tab?/:entityId`,
            element: <SimulatorsInputs />
        }
    ]
};
export default ConsultantRoutes;
